import React, { useState } from 'react';
import { Card, Typography, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import QueryForm from '../query/QueryForm';
import QueryRelatedQuestions from '../query/QueryRelatedQuestions';
import QueryExamples from '../query/QueryExamples';

const { Title } = Typography;

const QueryFormCard = ({
                         initialQuestion,
                         onSubmit,
                         handleExampleQuery,
                         hasRecentQueries,       // Optional prop: if true, show related questions instead of example queries
                         relatedQuestions,       // Array of related questions
                         previousQueryUuid,      // UUID from a recent query to use for query continuation
                       }) => {
  const { t } = useTranslation();
  const [deepResearchEnabled, setDeepResearchEnabled] = useState(false);

  console.log('relatedQuestions', relatedQuestions);

  return (
    <Card>
      <Title level={4} style={{ marginTop: '0', marginBottom: '15px' }}>
        {deepResearchEnabled ? t('query_new.deep_research_title') : t('query_new.title')}
      </Title>
      <QueryForm 
        initialQuestion={initialQuestion} 
        onSubmit={onSubmit} 
        onDeepResearchChange={setDeepResearchEnabled}
      />
      {!deepResearchEnabled && (
        <>
          <Title level={5}>{t('query_deep_research.title')}</Title>
          <div style={{ marginTop: '10px', marginBottom: '20px' }}>
            {t('query_deep_research.message')}
          </div>
        </>
      )}
      {(hasRecentQueries && relatedQuestions && relatedQuestions.length > 0) && !deepResearchEnabled && (
        <>
          <Title level={5}>{t('query_new.fields.continue_exploring_title')}</Title>
          <div style={{ marginTop: '20px' }}>
            <QueryRelatedQuestions
              relatedQuestions={relatedQuestions}
              previousQueryUuid={previousQueryUuid}
              queriesLandingPage={true}
            />
          </div>
        </>
      )}
      {(!relatedQuestions || relatedQuestions.length === 0) && !deepResearchEnabled && (
        <QueryExamples handleExampleQuery={handleExampleQuery} />
      )}
    </Card>
  );
};

export default QueryFormCard;
